module.exports = __webpack_public_path__ + "static/media/Eating.26181154.png";